/* INTEGY V231 — Quick Shop staged gallery + photo zoom prewarm — 11JUN2026 */
(function () {
  'use strict';
  if (window.INTEGY_V231_QUICKSHOP_STAGE_LOADED) return;
  window.INTEGY_V231_QUICKSHOP_STAGE_LOADED = true;

  function mq(q) { try { return window.matchMedia && window.matchMedia(q).matches; } catch (e) { return false; } }
  var desktop = mq('(min-width: 861px)');
  if (desktop) document.documentElement.classList.add('integy-v231-quickshop-stage');

  function qsa(sel, root) { try { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); } catch (e) { return []; } }
  function qs(sel, root) { try { return (root || document).querySelector(sel); } catch (e) { return null; } }
  function set(el, prop, value) { if (el && el.style) el.style.setProperty(prop, value, 'important'); }

  var originalFetch = window.fetch ? window.fetch.bind(window) : null;
  var htmlCache = window.INTEGY_QS_HTML_CACHE || (window.INTEGY_QS_HTML_CACHE = Object.create(null));
  var inFlight = window.INTEGY_QS_INFLIGHT || (window.INTEGY_QS_INFLIGHT = Object.create(null));
  var warmed = Object.create(null);

  function warmImage(url, highPriority) {
    if (!url || warmed[url]) return;
    warmed[url] = 1;
    try {
      var img = new Image();
      img.decoding = 'async';
      if ('fetchPriority' in img) img.fetchPriority = highPriority ? 'high' : 'low';
      img.src = url;
    } catch (e) {}
  }

  function currentImageUrl(img) {
    if (!img) return '';
    return img.currentSrc || img.getAttribute('src') || img.src || img.getAttribute('data-src') || img.getAttribute('data-zoom') || img.getAttribute('data-photoswipe-src') || '';
  }

  function highResUrl(img) {
    if (!img) return '';
    return img.getAttribute('data-photoswipe-src') || img.getAttribute('data-zoom') || currentImageUrl(img);
  }

  function quickshopUrl(raw) {
    if (!raw) return '';
    try {
      var u = new URL(raw, window.location.origin);
      if (!/\/products\//.test(u.pathname)) return '';
      u.searchParams.set('view', 'quickshop');
      return u.toString();
    } catch (e) { return ''; }
  }

  function isQuickshopFetch(input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    return /\/products\//.test(url) && /[?&]view=quickshop\b/.test(url);
  }

  function warmHtmlImages(text) {
    if (!text) return;
    var urls = [];
    text.replace(/<img\b[^>]*(?:class=["'][^"']*media__image[^"']*["'][^>]*)?>/gi, function (tag) {
      var m = tag.match(/\ssrc=["']([^"']+)["']/i) || tag.match(/\sdata-photoswipe-src=["']([^"']+)["']/i) || tag.match(/\sdata-zoom=["']([^"']+)["']/i);
      if (m && m[1]) urls.push(m[1].replace(/&amp;/g, '&'));
      return tag;
    });
    urls.slice(0, 4).forEach(function (u, i) { setTimeout(function () { warmImage(u, i === 0); }, i * 80); });
  }

  if (desktop && originalFetch && !window.INTEGY_V231_FETCH_PATCHED) {
    window.INTEGY_V231_FETCH_PATCHED = true;
    window.fetch = function (input, init) {
      if (isQuickshopFetch(input)) {
        var raw = typeof input === 'string' ? input : input.url;
        var key = quickshopUrl(raw) || raw;
        if (htmlCache[key]) {
          return Promise.resolve(new Response(htmlCache[key], {
            status: 200,
            headers: { 'Content-Type': 'text/html; charset=utf-8', 'X-Integy-QuickShop-Cache': 'v231-hit' }
          }));
        }
        if (inFlight[key]) {
          return inFlight[key].then(function (text) {
            return new Response(text, {
              status: 200,
              headers: { 'Content-Type': 'text/html; charset=utf-8', 'X-Integy-QuickShop-Cache': 'v231-inflight' }
            });
          });
        }
        return originalFetch(input, init).then(function (res) {
          try {
            res.clone().text().then(function (text) {
              if (text && text.indexOf('product__container--quick-shop') !== -1) {
                htmlCache[key] = text;
                warmHtmlImages(text);
              }
            }).catch(function () {});
          } catch (e) {}
          return res;
        });
      }
      return originalFetch(input, init);
    };
  }

  function prefetchQuickshop(url, highPriority) {
    if (!desktop || !originalFetch) return;
    var key = quickshopUrl(url);
    if (!key || htmlCache[key] || inFlight[key]) return;
    inFlight[key] = originalFetch(key, {
      credentials: 'same-origin',
      cache: 'force-cache',
      priority: highPriority ? 'high' : 'low'
    }).then(function (res) { return res.text(); })
      .then(function (text) {
        if (text && text.indexOf('product__container--quick-shop') !== -1) {
          htmlCache[key] = text;
          warmHtmlImages(text);
        }
        delete inFlight[key];
        return text;
      })
      .catch(function () { delete inFlight[key]; return ''; });
  }

  function cardUrl(el) {
    if (!el) return '';
    var card = el.closest ? el.closest('[data-product-quickshop-url],.productgrid--item,.productitem,[data-product-item]') : null;
    if (card) {
      var direct = card.getAttribute('data-product-quickshop-url');
      if (direct) return direct;
      var link = qs('a[href*="/products/"]', card);
      if (link) return link.href || link.getAttribute('href') || '';
    }
    var a = el.closest && el.closest('a[href*="/products/"]');
    return a ? (a.href || a.getAttribute('href') || '') : '';
  }

  function prefetchVisibleCards() {
    if (!desktop) return;
    qsa('[data-product-quickshop-url],.productgrid--item,.productitem').slice(0, 24).forEach(function (card, i) {
      var url = cardUrl(card);
      if (url) setTimeout(function () { prefetchQuickshop(url, false); }, i * 55);
    });
  }

  function collectStageImages(pg) {
    var slides = qsa('.product-gallery__viewer .swiper-slide', pg);
    var imgs = slides.map(function (s) { return qs('img.media__image,img[data-photoswipe-image],img', s); }).filter(Boolean);
    if (!imgs.length) imgs = qsa('img.media__image,img[data-photoswipe-image]', pg);
    return imgs;
  }

  function thumbnailItems(pg) {
    var items = qsa('.product-gallery__navigation [data-swiper-thumbnail]', pg);
    if (!items.length) items = qsa('.product-gallery__navigation .swiper-slide', pg);
    return items.filter(function (el) { return !!qs('img', el); });
  }

  function installStage(modal) {
    if (!desktop || !modal) return;
    modal.classList.add('integy-v231-quickshop-modal');
    qsa('product-gallery.product-gallery,.product-gallery', modal).forEach(function (pg) {
      if (pg.__integyV231Installed) {
        return;
      }
      var imgs = collectStageImages(pg);
      if (!imgs.length) return;
      pg.__integyV231Installed = true;
      pg.setAttribute('image-hover-zoom', 'disabled');
      pg.removeAttribute('image-crop');

      var viewer = qs('.product-gallery__viewer,[data-swiper-viewer]', pg);
      var nav = qs('.product-gallery__navigation,[data-swiper-navigation]', pg);
      var stage = qs('.integy-v231-qshop-stage', pg);
      if (!stage) {
        stage = document.createElement('div');
        stage.className = 'integy-v231-qshop-stage';
        stage.setAttribute('role', 'img');
        stage.setAttribute('aria-label', 'Quick Shop product image');
        var stageImg = document.createElement('img');
        stageImg.decoding = 'async';
        stageImg.loading = 'eager';
        if ('fetchPriority' in stageImg) stageImg.fetchPriority = 'high';
        stage.appendChild(stageImg);
        pg.insertBefore(stage, viewer || pg.firstChild);
      }

      var stageImgEl = qs('img', stage);
      var thumbs = thumbnailItems(pg);

      function setThumbActive(index) {
        thumbs.forEach(function (t, i) {
          t.classList.toggle('integy-v231-thumb-active', i === index);
          t.classList.toggle('swiper-slide-thumb-active', i === index);
        });
      }

      function setStage(index, highPriority) {
        imgs = collectStageImages(pg);
        thumbs = thumbnailItems(pg);
        if (!imgs.length) return;
        if (index < 0 || index >= imgs.length) index = 0;
        var img = imgs[index] || imgs[0];
        var thumbImg = thumbs[index] ? qs('img', thumbs[index]) : null;
        var src = currentImageUrl(img) || currentImageUrl(thumbImg);
        var srcset = img.getAttribute('srcset') || '';
        var alt = img.getAttribute('alt') || (thumbImg && thumbImg.getAttribute('alt')) || '';
        if (!src) return;

        stageImgEl.alt = alt;
        stageImgEl.sizes = '(min-width: 861px) 650px, 100vw';
        if (srcset) stageImgEl.srcset = srcset;
        else stageImgEl.removeAttribute('srcset');
        if ('fetchPriority' in stageImgEl) stageImgEl.fetchPriority = highPriority ? 'high' : 'auto';
        if (stageImgEl.src !== src) stageImgEl.src = src;
        setThumbActive(index);
        warmImage(src, !!highPriority);
        warmImage(highResUrl(img), false);
        var next = imgs[index + 1] || imgs[index - 1];
        warmImage(currentImageUrl(next), false);
      }

      var initial = parseInt(pg.getAttribute('initial-slide') || '0', 10) || 0;
      var activeThumb = thumbs.findIndex(function (t) { return t.classList.contains('swiper-slide-thumb-active'); });
      if (activeThumb >= 0) initial = activeThumb;
      setStage(initial, true);
      imgs.slice(0, 4).forEach(function (img, i) { setTimeout(function () { warmImage(currentImageUrl(img), i === 0); }, 100 + i * 80); });

      thumbs.forEach(function (thumb, i) {
        ['click','pointerdown'].forEach(function (evtName) {
          thumb.addEventListener(evtName, function (evt) {
            evt.preventDefault();
            evt.stopImmediatePropagation();
            setStage(i, true);
          }, true);
        });
        thumb.addEventListener('mouseenter', function () { setStage(i, false); }, { passive: true });
        thumb.addEventListener('focusin', function () { setStage(i, false); }, true);
      });

      if (nav) {
        nav.addEventListener('click', function (evt) {
          var target = evt.target && evt.target.closest && evt.target.closest('[data-swiper-thumbnail],.swiper-slide');
          if (!target) return;
          var idx = thumbnailItems(pg).indexOf(target);
          if (idx >= 0) {
            evt.preventDefault();
            evt.stopImmediatePropagation();
            setStage(idx, true);
          }
        }, true);
      }
    });
  }

  function enforceQuickshop() {
    if (!desktop) return;
    qsa('.modal--quickshop-full,[data-modal-container].modal--quickshop-full').forEach(function (modal) {
      qsa('.product__container--quick-shop', modal).forEach(function (container) {
        set(container, 'display', 'block');
        set(container, 'width', '100%');
        set(container, 'height', '100%');
        set(container, 'overflow', 'hidden');
      });
      qsa('.product__container--quick-shop > .product--outer,.product--outer', modal).forEach(function (outer) {
        set(outer, 'display', 'grid');
        set(outer, 'grid-template-columns', window.innerWidth < 1120 ? 'minmax(0, 1fr) minmax(330px, 360px)' : 'minmax(0, 650px) minmax(360px, 390px)');
        set(outer, 'gap', '24px');
        set(outer, 'height', '100%');
        set(outer, 'overflow', 'hidden');
      });
      qsa('.product-main', modal).forEach(function (main) {
        set(main, 'grid-column', '2 / 3');
        set(main, 'max-width', window.innerWidth < 1120 ? '360px' : '390px');
        set(main, 'height', '100%');
        set(main, 'overflow-y', 'auto');
        set(main, 'overflow-x', 'hidden');
      });
      qsa('.product-gallery__zoom-container,[data-zoom-container],.drift-zoom-pane,.drift-bounding-box', modal).forEach(function (el) {
        set(el, 'display', 'none');
        set(el, 'visibility', 'hidden');
        set(el, 'opacity', '0');
        set(el, 'pointer-events', 'none');
        try { el.innerHTML = ''; } catch (e) {}
      });
      installStage(modal);
    });
  }

  function warmProductPageZooms(highPriority) {
    qsa('img[data-photoswipe-src],img[data-zoom]').slice(0, 5).forEach(function (img, i) {
      setTimeout(function () { warmImage(highResUrl(img), highPriority && i === 0); }, i * 90);
    });
  }

  document.addEventListener('pointerenter', function (e) {
    if (!desktop) return;
    var url = cardUrl(e.target);
    if (url) prefetchQuickshop(url, false);
  }, true);

  document.addEventListener('focusin', function (e) {
    if (!desktop) return;
    var url = cardUrl(e.target);
    if (url) prefetchQuickshop(url, false);
  }, true);

  document.addEventListener('pointerdown', function (e) {
    var target = e.target;
    if (desktop) {
      var btn = target && target.closest && target.closest('[data-quickshop-full],.quickshop-button,.productitem--action');
      if (btn) {
        var url = cardUrl(btn);
        if (url) prefetchQuickshop(url, true);
        [0, 30, 90, 180, 350, 700].forEach(function (ms) { setTimeout(enforceQuickshop, ms); });
      }
    }
    if (target && target.closest && target.closest('[data-photoswipe-trigger-for],.media__lightbox-button,.swiper-slide__inner--cursor-pointer--always')) {
      var media = target.closest('.swiper-slide__inner,.media') || document;
      var img = qs('img[data-photoswipe-src],img[data-zoom]', media) || qs('img[data-photoswipe-src],img[data-zoom]');
      warmImage(highResUrl(img), true);
    }
  }, true);

  function boot() {
    enforceQuickshop();
    setTimeout(prefetchVisibleCards, 650);
    if ('requestIdleCallback' in window) requestIdleCallback(function () { warmProductPageZooms(false); }, { timeout: 2200 });
    else setTimeout(function () { warmProductPageZooms(false); }, 1400);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();

  window.addEventListener('pageshow', function () { setTimeout(boot, 0); }, { passive: true });
  window.addEventListener('resize', function () { setTimeout(enforceQuickshop, 100); }, { passive: true });

  try {
    new MutationObserver(function () { enforceQuickshop(); }).observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {}

  if (desktop) setInterval(enforceQuickshop, 650);
})();
